import React, { useState, useEffect } from "react";
import VideoPlayer from "../components/VideoPlayer";
import api from "../services/api";
import { useAuth } from "../utils/auth"; // assuming context API is set
import FullscreenVideoModal from "../services/videoService";
import { useNavigate } from "react-router-dom";

const EpisodeList = ({ episodes, seasonName }) => {

  

  const [wishlist, setWishlist] = useState([]);
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  const [videoFile, setVideoFile] = useState(null);
const [showVideo, setShowVideo] = useState(false);

const handleWatchClick = (id) => {
  // Only trigger if modal is not already shown
  if (!videoFile) {
    setVideoFile(id);
    setShowVideo(true);
  }
};


  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate("/login");
      } else if (user.plan_status !== "ACTIVE") {
        navigate("/membership-plan");
      }
    }
  }, [user, loading, navigate]);


  // Load wishlist on mount
  useEffect(() => {
    if (user) {
      api.get("/api/wishlist", { withCredentials: true }).then((res) => {
        const ids = res.data.map(item => item.episode_id);
        setWishlist(ids);
      });
    }
  }, [user]);

  // Toggle wishlist item
  const toggleWishlist = async (episodeId, videoUrl) => {
    try {
      const res = await api.post(
        "/api/wishlist/toggle",
        { episode_id: episodeId, video_url: videoUrl },
        { withCredentials: true }
      );

      setWishlist((prev) =>
        res.data.added
          ? [...prev, episodeId]
          : prev.filter((id) => id !== episodeId)
      );
    } catch (err) {
      console.error("Error updating wishlist:", err);
    }
  };
  useEffect(() => {
    if (videoFile) {
      setShowVideo(true);
    }
  }, [videoFile]);



  return (
    <div className="space-y-16 py-12 px-6">
      {episodes.map((ep, idx) => (
        <div key={ep.id} className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          {/* Video Section */}
          <div className="w-full h-[300px] relative overflow-hidden rounded-md">
            <VideoPlayer url={ep.videoUrl} thumbnail={ep.thumbnail} />
          </div>

          {/* Description Section */}
          <div className="space-y-4 font-['EB_Garamond','Nunito','sans-serif']">
            <h2 className="text-lg font-semibold">{ep.title}</h2>
            <h3 className="text-xl font-bold font-['EB_Garamond','Nunito','sans-serif']">{ep.subtitle}</h3>
            <p className="text-justify text-black text-lg">{ep.details}</p>
            <div className="flex space-x-4 mt-4">
              <button
                className="relative px-6 py-2 font-semibold   text-[rgb(234,126,93)] hover:bg-[rgb(234,126,93)] hover:text-white transition duration-300 after:block after:h-[2px] after:bg-[rgb(234,126,93)] after:mt-1 after:w-full"
                onClick={() => handleWatchClick(ep.id)}
              >
                Watch Now
              </button>
                {showVideo && videoFile && (
                  <FullscreenVideoModal
                    key={videoFile}
                    filename={videoFile}
                    onClose={() => {
                      setShowVideo(false);
                      setVideoFile(null);
                    }}
                  />
                )}

              <button
                className="relative px-6 py-2 font-semibold  text-[rgb(234,126,93)] hover:bg-[rgb(234,126,93)] hover:text-white transition duration-300 after:block after:h-[2px] after:bg-[rgb(234,126,93)] after:mt-1 after:w-full"
                onClick={() => toggleWishlist(ep.id, seasonName)}
              >
                {wishlist.includes(ep.id) ? "Remove from Watchlist" : "Add to Watchlist"}
              </button>
            </div>
          </div>

          {/* Divider */}
          {idx !== episodes.length - 1 && (
            <div className="col-span-2 h-[1px] bg-[rgb(234,126,93)] my-8" />
          )}
        </div>
      ))}
    </div>
  );
};

export default EpisodeList;